// DO NOT REMOVE A FLAG UNTIL QUERIES THAT NO LONGER USE THE FLAG IS RELEASED TO PROD
export enum FeatureFlagKey {
  PlaceHolder = 'placeHolder',
  Surveys2025 = 'surveys_2025',
}

// DO NOT REMOVE A DEFAULT VALUE UNTIL CODE THAT NO LONGER USES THE FLAG IS RELEASED TO PROD
export const featureFlagKeyToDefaultValueMap: Record<FeatureFlagKey, boolean> = {
  [FeatureFlagKey.PlaceHolder]: false,
  [FeatureFlagKey.Surveys2025]: false,
};
